export default __webpack_public_path__ + "static/media/article.66f52b3f.jpg";